module.exports = __webpack_public_path__ + "static/media/app-filters.29da8c31.jpeg";